import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { t } from "i18next";
import { useFetch } from "../../../../hooks/useFetch";
import { EquipmentType } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Input } from "../../../../ui/Input/Input";
import { Button } from "../../../../ui/Button";
import DeleteType from "./deleteType";
import { Separator } from "../../../../ui/Separator";
import { useAppStore } from "../../../../stores/RootStore";

type Props = {
  id: string | undefined;
  currentEquipmentType: EquipmentType | undefined;
};

const TypesSettingsTab = ({ id, currentEquipmentType }: Props) => {
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: currentEquipmentType?.attributes.name,
    },
  });

  const [{ response: itemUpdateResponse, isLoading: itemUpdateIsLoading, error: itemUpdateError }, doFetchItemUpdate] =
    useFetch(`/directories/equipment_types/${id}`);

  const equipmentTypes = useAppStore((store) => store.equipmentTypes)!;
  const setEquipmentTypes = useAppStore((store) => store.setEquipmentTypes);

  const editEquipmentTypeItem = (itemSaveResponse: { data: unknown }) => {
    const newCurrentItemData = itemSaveResponse.data as unknown as EquipmentType;
    const withoutCurrentItem = equipmentTypes?.filter((equipmentType) => equipmentType.id != currentEquipmentType?.id)!;
    setEquipmentTypes([...withoutCurrentItem, newCurrentItemData]);
  };

  useEffect(() => {
    if (itemUpdateResponse) {
      editEquipmentTypeItem(itemUpdateResponse);
    }
  }, [itemUpdateResponse]);

  const onSubmit = (formData: any) => {
    doFetchItemUpdate({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
        },
      },
    });
  };

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  return (
    <>
      <div className="px-6">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <div className="flex flex-col gap-3">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={t("title_name")} />
                  </div>
                )}
              />
              <div className="mt-8 flex w-full justify-between">
                <Button variant={"destructive"} size={"sm"} type="button" onClick={() => openDeleteModal()}>
                  {t("delete")}
                </Button>
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      <DeleteType id={id!} isDeleteOpen={isDeleteOpen} closeModal={closeDeleteModal} />
    </>
  );
};

export default TypesSettingsTab;
